/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.1.0
 * @since 1.1.0
 */

import { memo } from 'react';

import { RangeMonthPickerItemStyled } from './styled/RangeMonthPickerStyled';

const RangeMonthPickerItem = (props: IRangeMonthPickerItem) => {
    const onClickMonth = () => {
        if (!props.disabled) {
            props.onClickMonth();
        }
    };

    return (
        <RangeMonthPickerItemStyled
            className={[
                'date-picker-item',
                props.inRange ? 'date-picker-item--in-range' : '',
                props.rangeStart ? 'date-picker-item--range-start' : '',
                props.rangeEnd ? 'date-picker-item--range-end' : '',
                props.disabled ? 'date-picker-item--disabled' : '',
            ].join(' ')}
            data-name={props.dataName}
            onClick={onClickMonth}>
            <div>{props.children}</div>
        </RangeMonthPickerItemStyled>
    );
};

export interface IRangeMonthPickerItem {
    children?: any;
    dataName?: string;
    disabled: boolean;
    inRange: boolean;
    onClickMonth: () => void;
    rangeStart: boolean;
    rangeEnd: boolean;
}

export default memo(RangeMonthPickerItem);
